import React from 'react'
import styled from 'styled-components'

import { countBy, keys, round, sum } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { PARTS } from '../parts/stages'
import check from '../rules/engine';
import rules from '../rules';

const Container = styled.div`
    border: solid;
    border-color: darkgrey;
    border-radius: .5em;
    height: 100%;
    padding: 10px;
    overflow: scroll;
    flex: 2;
`

const Heading = styled.h2`
`
const Warning = styled.div`
color: orange;
display:flex;
align-content: center;
`
const Error = styled.div`
color: red;
display:flex;
align-content: center;
`

const ErrorValue = styled.div`
    margin-top:auto;
    margin-bottom: auto;
`

const SubHeading = styled.h4``

const ErrorIcon = styled.span`
    font-size: 3em;
    padding-right: .2em;
    width: 2em;
    justify-content: center;
`

const Analysis = ({ error }) => {
    switch (error.severity) {
        case 'warning':
            return (<Warning>
                <ErrorIcon><FontAwesomeIcon icon={faExclamation} /></ErrorIcon><ErrorValue>{error.val}</ErrorValue>
            </Warning>)
        case 'error':
            return (<Error>
                <ErrorIcon><FontAwesomeIcon icon={faTimes} /></ErrorIcon><ErrorValue>{error.val}</ErrorValue>
            </Error>)
    }
}



const ResultsArea = ({ stages = [], input, output }) => {
    const stageParts = stages.reduce((acc, stage) => acc.concat(stage.parts), [])
    const partsList = [...input ? input.parts : [], ...output ? output.parts : [], ...stageParts].sort()
    const partsTable = countBy(partsList)
    const stageCost = stageParts.map(p => PARTS[p].cost).reduce((s, v) => s + v, 0)
    const inputCost = input ? input.parts.map(p => PARTS[p].cost).reduce((sum, val) => sum + val) : 0
    const outputCost = output ? output.parts.map(p => PARTS[p].cost).reduce((sum, val) => sum + val) : 0
    const cost = round(stageCost + inputCost + outputCost, 2)
    const analysis = check({ stages, input, output }, rules)
    const reduction = stages.reduce((acc, stage) => stage.reduction * acc, 1)
    const torque = (input ? input.inputTorque : 0) * reduction
    return (
        <Container>
            <Heading>Analysis</Heading>
            <SubHeading>{analysis.length > 0 ? 'Concerns' : null}</SubHeading>
            {analysis.map((err, i) => {
                return (<Analysis key={i} error={err}></Analysis>)
            })}
            <SubHeading>Reduction: {reduction}:1</SubHeading>
            <SubHeading>Stall Torque: {torque} N-m</SubHeading>
            <SubHeading>Cost: ${cost}</SubHeading>
            <SubHeading>Parts Required</SubHeading>
            <ul>
                {keys(partsTable).map(k => <li key={k}> {k} x {partsTable[k]} - {PARTS[k].name}</li>)}
            </ul>


        </Container>
    )
}



export default ResultsArea;